import { UserStatus } from "types";

export enum ApplicationStatusEnum {
  SUBMITTED = "SUBMITTED",
  UNDER_REVIEW = "UNDER_REVIEW",
  AWAITING_DOCUMENTS = "AWAITING_DOCUMENTS",
  CONDITIONAL_OFFER_ISSUED = "CONDITIONAL_OFFER_ISSUED",
  UNCONDITIONAL_OFFER_ISSUED = "UNCONDITIONAL_OFFER_ISSUED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  WITHDRAWN = "WITHDRAWN",
}

export const applicationStatusOptions = [
  { value: ApplicationStatusEnum.SUBMITTED, label: "Submitted" },
  { value: ApplicationStatusEnum.UNDER_REVIEW, label: "Under Review" },
  {
    value: ApplicationStatusEnum.AWAITING_DOCUMENTS,
    label: "Awaiting Documents",
  },
  {
    value: ApplicationStatusEnum.CONDITIONAL_OFFER_ISSUED,
    label: "Conditional Offer Issued",
  },
  {
    value: ApplicationStatusEnum.UNCONDITIONAL_OFFER_ISSUED,
    label: "Unconditional Offer Issued",
  },
  { value: ApplicationStatusEnum.ACCEPTED, label: "Accepted" },
  { value: ApplicationStatusEnum.REJECTED, label: "Rejected" },
  { value: ApplicationStatusEnum.WITHDRAWN, label: "Withdrawn" },
];

export enum InquiryStatusEnum {
  ACTIVE = "ACTIVE",
  RESPONDED = "RESPONDED",
  CONVERTED = "CONVERTED",
  CLOSED = "CLOSED",
}

export const inquiryStatusOptions = [
  { value: InquiryStatusEnum.ACTIVE, label: "Active" },
  { value: InquiryStatusEnum.RESPONDED, label: "Responded" },
  { value: InquiryStatusEnum.CONVERTED, label: "Converted" },
  { value: InquiryStatusEnum.CLOSED, label: "Closed" },
];

export const userStatusOptions = [
  { value: UserStatus.PENDING, label: "Pending" },
  { value: UserStatus.CONFIRMED, label: "Confirmed" },
  { value: UserStatus.DISABLED, label: "Disabled" },
];
